module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "def_juris_btn"
  }, [(_vm.set_style == 1) ? [_c('el-button', {
    attrs: {
      "size": _vm.set_size,
      "type": _vm.set_type,
      "disabled": !_vm.view_state
    }
  }, [_vm._t("default")], 2)] : (_vm.view_state) ? [_c('el-button', {
    attrs: {
      "size": _vm.set_size,
      "type": _vm.set_type
    }
  }, [_vm._t("default")], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-c68a0026"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/Jurisdiction/jurs_btn.vue
// module id = 1560
// module chunks = 1